(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["riley-watch-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('.riley-watch-nav')?.querySelector('dropdown-menu-disclosure');
    if (!menu?.querySelector('details[open]')) return;
    event.preventDefault();
    event.stopPropagation();
    menu.toggle(false);
    menu.querySelector('summary').focus();
  }, true);
  } catch(e) { console.error(e); }
})();

})();
